/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
import React, { useState, useEffect, useRef } from 'react';
import '../../../Components/Utility/Utility.css';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Dropdown, Button } from 'react-bootstrap';
import { useHistory, Link, useParams, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import BtnAdd from '../../../Components/Utility/FilterAction/BtnAdd';
import BtnDelete from '../../../Components/Utility/FilterAction/BtnDelete';
import BtnSelectAll from '../../../Components/Utility/FilterAction/BtnSelectAll';
import SearchBar from '../../../Components/Utility/FilterAction/SearchBar';
import BtnAddGroup from '../../../Components/Utility/FilterAction/BtnAddGroup';
import BtnSort from '../../../Components/Utility/FilterAction/BtnSort';
import AddEditBomLibrary from './AddEditBomLibrary';
import * as supplierAction from '../../Supplier/store/Supplier.action';
import * as masterAction from '../../SystemMasters/Store/SystemMasters.action';
import BomLibraryCard from '../../../Components/Card/BomLibraryCard/BomLibraryCard';
import * as bTypeAction from '../BomType/Store/BomType.action';
import * as action from './store/BomLibrary.action';
import Loader from '../../../Components/Utility/Loader/Loader';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import BomExpand from '../../DevlopmentOrder/Bom/BomExpand/BomExpand';
import { shortenString, pageSize, treadFile, imageUrl, bomUsageFields } from '../../../Components/helper';
import ComponentFilter from '../../../Components/Utility/FilterAction/ComponentFilter';
import BomLibraryTagsModel from './bomLibraryTags/bomLibraryTagsModel';
import './bomlibrary.css';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import ImportModal from './ImportModal';
import ConfirmationModalForUpload from './ConfirmationModalForUpload';
import ErrorModal from './ErrorModal';
import { toasterMsg } from '../../../Components/Toaster/Toaster';

const sortByOptions = [
  {
    value: 'Asc',
    propertyName: 'referenceCode',
    label: 'Component Name (Ascending)',
  },
  {
    value: 'Desc',
    propertyName: 'referenceCode',
    label: 'Component Name (Descending)',
  },
];

function CustomBom({ match }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const urlParams = useParams();
  const location = useLocation();
  const reducer = useSelector((estate) => estate);
  const { UserDetails, BomLibraryDetails, BOMConfigDetails, Users } = reducer;
  const { isSupplierLoggedIn, userInfo } = UserDetails;
  const { BOMProperty, BOMLibraryList, TotalCount, ReferenceSupplier, newBomLibraryList } = BomLibraryDetails;
  const { suppliers } = BOMConfigDetails;
  const { t } = useTranslation('common');
  const devOrderId = match?.params?.devOrderId;
  const loggedInUserId = userInfo.userId;
  const { logInRights } = Users;
  const bomLibrary = t('BOM_TYPE_VIEW.BOM_TYPE_POPUP_VIEW.BOM_LIBRARY');
  const [isAddEditClick, setIsAddEditClick] = useState(false);

  const { CheckActionPermission } = useComponent();

  const addEditAccess = CheckActionPermission(logInRights, 'libraries', 'bom', 'addEdit');
  const dppAddEditAccess = CheckActionPermission(logInRights, 'dpp', 'all', 'addEdit');

  const [bomLibraryGroups, setBomLibraryGroups] = useState([]);
  const [showSearchMobile, setSearchMobile] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [bomLibraryModal, setBomLibraryModal] = useState({ show: false });
  const [selectedId, setSelectedId] = useState(null);
  const [isSelectAll, setSelectAll] = useState(false);
  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [selectedBomId, setBomId] = useState(null);
  const [expand, setExpand] = useState(false);
  const [inFilter, setInFilter] = useState(false);
  const [selectedExpand, setselectedExpand] = useState(null);
  const [selectedCompSupplier, setSelectedCompSupplier] = useState(null);
  const [selectedCompType, setSelectedCompType] = useState(null);
  const [selectedFinish, setSelectedFinish] = useState(null);
  const [selectedComposition, setSelectedComposition] = useState(null);
  const [selectedCreatedBy, setSelectedCreatedBy] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedSubBrand, setSelectedSubBrand] = useState(null);
  const [selectedProductType, setSelectedProductType] = useState(null);
  const [show, setShow] = useState(false);
  const [selectedCategory1, setSelectedCategory1] = useState(null);
  const [selectedCategory2, setSelectedCategory2] = useState(null);
  const [selectedCategory3, setSelectedCategory3] = useState(null);
  const [selectedCategory4, setSelectedCategory4] = useState(null);
  const [fileName, setFileName] = useState([]);
  const [errorShow, setErrorShow] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [uploadData, setUploadData] = useState({});
  const [composition, setComposition] = useState({});
  const [checked, setChecked] = useState(false);
  const [bulkUpdateFields, setBulkUpdateFields] = useState([]);
  const [showBulkUpdateSuccess, setShowBulkUpdateSuccess] = useState(false);

  const [state, setState] = useState({
    bomLibraryList: [],
    pageIndex: 1,
    pageSize,
    hasMore: false,
    loading: false,
    totalRecords: 0,
    searchText: '',
    searchLoaded: false,
    sortBy: null,
  });

  const [subBrandAccess, setSubBrandAccess] = useState(false);
  const paramId = match.params.id;
  const [addBomTagsModal, setAddBomTagsModal] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [downloadSelectLoading, setDownloadSelectLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState({});

  const docRef = useRef(null);

  const [selectedTagId, setSelectedTagId] = useState();
  const openBomLibraryPopup = () => {
    setSelectedId(null);
    setBomLibraryModal({ show: true });
    setIsAddEditClick(true);
  };
  const [searchtagselected, setSearchtagselected] = useState([]);
  const [bomFilterType, setBomFilterType] = useState({
    value: bomLibrary,
    label: bomLibrary,
  });
  const tagListBoms = useSelector((st) => st.BomLibraryDetails.tagsList);
  const [tagListBom, setTagListBom] = useState([]);
  const localstorageFilter = JSON.parse(localStorage.getItem('libraryBOMFilter'));
  useEffect(() => {
    setTagListBom(tagListBoms);
  }, [bomFilterType, tagListBoms]);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      bomLibraryList: [...newBomLibraryList],
    }));
  }, [newBomLibraryList]);

  const onEdit = (id) => {
    if (id) {
      setSelectedId(id);
      setBomLibraryModal({ show: true });
      setIsAddEditClick(true);
    }
  };

  /*
   * BOM Library V2 has no add/edit form of its own yet, so its Add and Edit
   * actions route here carrying what to open in the router's location state.
   * Held until this route's BOM type has loaded — the store keeps whichever type
   * was loaded last — since the form is titled and configured from it, then
   * cleared so a refresh lands on the plain list.
   */
  const [formHandoff, setFormHandoff] = useState(() =>
    location.state?.openAdd || location.state?.editId ? location.state : null,
  );

  useEffect(() => {
    if (!formHandoff || !BOMProperty?.name || BOMProperty._id !== paramId) {
      return;
    }
    setFormHandoff(null);
    history.replace({ pathname: location.pathname, state: null });
    if (formHandoff.editId) {
      onEdit(formHandoff.editId);
      return;
    }
    openBomLibraryPopup();
  }, [formHandoff, BOMProperty]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (selectedBrand) {
      dispatch(masterAction.getMultiSubBrandDetails({ brandId: [selectedBrand._id] }));
    }
  }, [selectedBrand]);

  const onClose = () => {
    setSelectedId(null);
    setBomLibraryModal(!bomLibraryModal.show);
    setIsAddEditClick(false);
  };

  const hasNullValues = (obj) => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== null) {
        return false;
      }
    }
    return true;
  };

  const paramsForFilter = {
    componentSupplier: selectedCompSupplier?._id ?? null,
    componentType: selectedCompType?._id ?? null,
    composition: selectedComposition?._id ?? null,
    finished: selectedFinish?._id ?? null,
    createdBy: selectedCreatedBy?._id ?? null,
    brand: selectedBrand?._id ?? null,
    subBrand: selectedSubBrand?._id ?? null,
    productType: selectedProductType?._id ?? null,
    category1: selectedCategory1?._id ?? null,
    category2: selectedCategory2?._id ?? null,
    category3: selectedCategory3?._id ?? null,
    category4: selectedCategory4?._id ?? null,
  };
  const isFilterNull = hasNullValues(paramsForFilter);

  const handleSortBy = async (val) => {
    setState((sortstate) => ({
      ...sortstate,
      sortBy: val,
      loading: true,
      pageIndex: 1,
      bomLibraryList: [],
      totalRecords: null,
      hasMore: false,
    }));
    setSelectedIdArray([]);
    setBomId(null);
    setSelectAll(false);
    setState((bomLibEndstate) => ({
      ...bomLibEndstate,
      loading: true,
      bomLibraryList: [],
    }));
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      searchText: state.searchText,
      isSelectAll: false,
      bomTypeId: paramId,
      ...(!isFilterNull && { ...paramsForFilter }),
    };
    if (val?.value) {
      params.sortOrder = val?.value;
      params.sortPropertyName = val?.propertyName;
      localStorage.setItem(`librarySort_${paramId}`, JSON.stringify(val));
    } else {
      localStorage.removeItem(`librarySort_${paramId}`);
    }
    await Promise.all([dispatch(action.clearLibraryList()), dispatch(action.getBomLibraryGroup(params, t))]);
    setState((bomLibEndstate) => ({
      ...bomLibEndstate,
      loading: false,
    }));
  };

  const onSelectCheckBox = async (_e, id) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems.filter((item) => item === id);
    if (!isEmpty(findItems)) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
    } else {
      setSelectedIdArray([...selectedItems, id]);
    }
  };

  const deleteBomType = (id) => {
    setBomId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedIdArray([]);
    } else {
      const selectedItems = [...selectedIdArray];
      for (const item of state.bomLibraryList) {
        const findItems = selectedItems.filter((val) => val === item._id);
        if (findItems.length === 0) {
          selectedItems.push(item._id);
        }
      }
      setSelectedIdArray(selectedItems);
    }
    setSelectAll(!isSelectAll);
  };

  const deleteById = async () => {
    setState((del1state) => ({
      ...del1state,
      loading: true,
      // bomLibraryList: [],
    }));
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
    };
    if (selectedBomId) {
      params.bomLibId = [selectedBomId];
    } else {
      params.bomLibId = [...selectedIdArray];
    }
    const res = await dispatch(action.deleteBomBomLibaray(params, t));
    if (res) {
      setShowConfirmationPopup(!showConfirmationPopup);
      const params2 = {
        bomTypeId: paramId,
        pageIndex: 1,
        pageSize: state.pageSize,
        ...(state.searchText && { searchText: state.searchText }),
        ...(state.sortBy && { sortOrder: state.sortBy?.value, sortPropertyName: state.sortBy?.propertyName }),
        ...(!isFilterNull && { ...paramsForFilter }),
      };
      setSelectedIdArray([]);
      await Promise.all([dispatch(action.clearLibraryList()), dispatch(action.getBomLibraryGroup(params2, t))]);
    } else {
      setShowConfirmationPopup(!showConfirmationPopup);
    }
    setState((del2state) => ({
      ...del2state,
      loading: false,
    }));
  };

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((search1state) => ({
      ...search1state,
      searchText: targetValue,
      searchLoaded: true,
    }));
  };

  const handleMobileSearch = (clear) => {
    if (clear) {
      setState((mobstate) => ({
        ...mobstate,
        searchText: '',
        searchLoaded: true,
      }));
    }
    setSearchMobile(!showSearchMobile);
  };

  const openAddToGroup = async (val) => {
    let pathName;
    if (val !== 'add') {
      pathName = `/libraries/bom-library-group/edit/${paramId}/${val._id}`;
    } else {
      pathName = `/libraries/bom-library-group/add/${paramId}`;
    }
    history.push({
      pathname: pathName,
      state: { libIds: selectedIdArray },
    });
  };

  const handleExpandToogle = (id) => {
    if (expand) {
      setselectedExpand(null);
    } else {
      const filterBom = state.bomLibraryList.filter((item) => item._id === id);
      setselectedExpand(filterBom?.length > 0 ? filterBom[0] : null);
    }
    setExpand(!expand);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        setState((search2state) => ({
          ...search2state,
          loading: true,
          pageIndex: 1,
          bomLibraryList: [],
          totalRecords: null,
          hasMore: false,
        }));
        setSelectedIdArray([]);
        setBomId(null);
        setSelectAll(false);
        if (state?.searchText?.length > 0) {
          localStorage.setItem(`searchText_${paramId}`, state?.searchText);
        } else {
          localStorage.removeItem(`searchText_${paramId}`);
        }
        const params = {
          bomTypeId: paramId,
          pageIndex: 1,
          pageSize: state.pageSize,
          searchText: state.searchText,
          bomLibraryList: [],
          totalRecords: null,
          isSelectAll: false,
          selectedIdArray: [],
          ...(state.sortBy && { sortOrder: state.sortBy?.value, sortPropertyName: state.sortBy?.propertyName }),
          ...(!isFilterNull && { ...paramsForFilter }),
        };
        if (state?.sortBy) {
          params.sortOrder = state?.sortBy?.value;
          params.sortPropertyName = state?.sortBy?.propertyName;
        }
        await Promise.all([dispatch(action.clearLibraryList()), dispatch(action.getBomLibraryGroup(params, t))]);
        setState((endstate) => ({
          ...endstate,
          loading: false,
          searchLoaded: false,
        }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [state.searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (paramId == null || paramId === '') {
      return;
    }
    setState((effectstate) => ({
      ...effectstate,
      loading: true,
      bomLibraryList: [],
    }));
    const callBomAction = async () => {
      const res = await dispatch(bTypeAction.fetchBomTypeByIdAction(paramId));
      if (res) {
        if (res.code !== 200) {
          history.push('/libraries/bom-type');
          setSelectedIdArray([]);
        }
      }
    };
    callBomAction();
  }, [paramId]); // eslint-disable-line react-hooks/exhaustive-deps

  const onInit = async () => {
    const sortData = JSON.parse(localStorage.getItem(`librarySort_${paramId}`));
    const localSearch = localStorage.getItem(`searchText_${paramId}`);
    const fromLocalStorageSortData = sortData ? { sortOrder: sortData?.value, sortPropertyName: sortData?.propertyName } : {};
    const params = {
      bomTypeId: paramId,
      pageIndex: state.pageIndex,
      pageSize: state.pageSize,
      ...(!isFilterNull && { ...paramsForFilter }),
      searchText: localSearch || state?.searchText,
      ...(state.sortBy ? { sortOrder: state?.sortBy?.value, sortPropertyName: state?.sortBy?.propertyName } : fromLocalStorageSortData),
    };
    setState((initstate) => ({
      ...initstate,
      loading: true,
      bomLibraryList: [],
    }));

    const currentLibFilter = localstorageFilter?.find((ele) => {
      return ele[`${paramId}_Type`];
    });

    if (currentLibFilter) {
      const selectedIds = JSON.parse(currentLibFilter[`${paramId}_Type`].selectedIds);
      const selectedObjs = JSON.parse(currentLibFilter[`${paramId}_Type`].selectedObject);

      setInFilter(true);
      onSubmitFilter(selectedIds);
      setSelectedCompSupplier(selectedObjs.componentSupplier);
      setSelectedCompType(selectedObjs.componentType);
      setSelectedFinish(selectedObjs.finished);
      setSelectedComposition(selectedObjs.composition);
      setSelectedCreatedBy(selectedObjs.createdBy);
      setSelectedBrand(selectedObjs.brand);
      setSelectedSubBrand(selectedObjs.subBrand);
      setSelectedProductType(selectedObjs.productType);
      setSelectedCategory1(selectedObjs.category1);
      setSelectedCategory2(selectedObjs.category2);
      setSelectedCategory3(selectedObjs.category3);
      setSelectedCategory4(selectedObjs.category4);
    } else {
      await dispatch(action.getBomLibraryGroup(params, t));
    }

    const payload = {
      bomTypeId: paramId,
      isAllRecord: true,
    };
    const cat1Params = { accessedFrom: '', categoryType: 1, loggedInUserId, isActive: true };
    const cat2Params = { accessedFrom: '', categoryType: 2, loggedInUserId, isActive: true };
    await Promise.all([
      dispatch(supplierAction.fetchTier1SupplierListAction()),
      dispatch(supplierAction.fetchTier2AboveSupplierListAction()),
      dispatch(masterAction.getBrandDetails({ accessedFrom: '', loggedInUserId, isActive: true })),
      dispatch(masterAction.getCategory2Details(cat2Params)),
      dispatch(masterAction.getCategory1Details(cat1Params)),
      dispatch(masterAction.getFinalsDetails({ isActive: true })),
      dispatch(action.fetchBomReferenceType({ bomTypeId: paramId })),
      dispatch(action.fetchBomLibarayComposition({ isActive: 1, loggedInUserId: userInfo.userId, bomTypeId: paramId })),
      ...(subBrandAccess ? [dispatch(masterAction.getMultiSubBrandDetails({ loggedInUserId, isActive: true }))] : []),
    ]);
    const resp = await dispatch(action.fetchBomLibraryGroupOptions(payload));
    setBomLibraryGroups(resp || []);
    setState((initstate) => ({
      ...initstate,
      loading: false,
    }));
  };

  useEffect(() => {
    if (paramId == null || paramId === '') {
      return;
    }
    async function apiCalls() {
      if (localStorage.getItem(`searchText_${paramId}`)) {
        setState((prev) => ({
          ...prev,
          searchText: localStorage.getItem(`searchText_${paramId}`),
          ...(localStorage.getItem(`librarySort_${paramId}`) ? { sortBy: JSON.parse(localStorage.getItem(`librarySort_${paramId}`)) } : { sortBy: null }),
        }));
      }
      if (localStorage.getItem(`librarySort_${paramId}`)) {
        const sortData = JSON.parse(localStorage.getItem(`librarySort_${paramId}`));
        setState((prev) => ({
          ...prev,
          sortBy: sortData,
          ...(localStorage.getItem(`searchText_${paramId}`) ? { searchText: localStorage.getItem(`searchText_${paramId}`) } : { searchText: '' }),
        }));
      }

      // Fetch subbrand access
      const subBrandAccessRes = await dispatch(masterAction.getSubBrandAccess());
      setSubBrandAccess(subBrandAccessRes?.data || false);

      await onInit();
    }
    apiCalls();
    return async () => {
      await dispatch(action.emptyLibList());
    };
  }, [paramId, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const localStorageData = JSON.parse(localStorage.getItem('libraryBOMFilter'));
    if (localStorageData?.length > 0) {
      setState((prev) => ({
        ...prev,
        bomLibraryList: BOMLibraryList,
        totalRecords: TotalCount,
        hasMore: TotalCount > BOMLibraryList?.length,
        loading: false,
      }));
    }
    if (BOMLibraryList && BOMLibraryList?.length > 0 && (localStorageData?.length === 0 || !localStorageData)) {
      setState((prev) => ({
        ...prev,
        bomLibraryList: BOMLibraryList,
        totalRecords: TotalCount,
        hasMore: TotalCount > BOMLibraryList?.length,
        loading: false,
      }));
    }
  }, [BOMLibraryList]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    async function fetchApi() {
      if (userInfo?.userId) {
        await dispatch(action.fetchBomReferenceSupplier({ loggedInUserId: userInfo.userId }));
        if (!isSupplierLoggedIn) await dispatch(action.fetchUserList({ loggedInUserId: userInfo.userId }));
      }
    }

    fetchApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getBomLib = async (data, number) => {
    setState((bomLibstate) => ({
      ...bomLibstate,
      loading: true,
      bomLibraryList: [],
      ...data,
    }));
    const params = {
      bomTypeId: paramId,
      pageIndex: number || data.pageIndex,
      pageSize: data.pageSize,
      componentSupplier: selectedCompSupplier ? selectedCompSupplier?._id : null,
      componentType: selectedCompType ? selectedCompType?._id : null,
      composition: selectedComposition ? selectedComposition?._id : null,
      finished: selectedFinish ? selectedFinish?._id : null,
      createdBy: selectedCreatedBy ? selectedCreatedBy?._id : null,
      brand: selectedBrand ? selectedBrand?._id : null,
      subBrand: selectedSubBrand ? selectedSubBrand?._id : null,
      productType: selectedProductType ? selectedProductType?._id : null,
      category1: selectedCategory1 ? selectedCategory1?._id : null,
      category2: selectedCategory2 ? selectedCategory2?._id : null,
      category3: selectedCategory3 ? selectedCategory3?._id : null,
      category4: selectedCategory4 ? selectedCategory4?._id : null,
    };
    if (data.searchText) {
      params.searchText = data.searchText;
    }
    if (data.sortBy) {
      params.sortOrder = data.sortBy.value;
      params.sortPropertyName = data.sortBy.propertyName;
    }
    await dispatch(action.getBomLibraryGroup(params, t));
    setState((bomLibEndstate) => ({
      ...bomLibEndstate,
      loading: false,
    }));
  };

  const handleNextPagesInScroll = () => {
    let index = state.pageIndex;
    index += 1;
    const params = {
      pageIndex: index,
      pageSize: state.pageSize,
      searchText: state.searchText,
      sortBy: state.sortBy,
      bomLibraryList: state.bomLibraryList,
      totalRecords: state.totalRecords,
      isSelectAll,
      componentSupplier: selectedCompSupplier ? selectedCompSupplier?._id : null,
      componentType: selectedCompType ? selectedCompType?._id : null,
      composition: selectedComposition ? selectedComposition?._id : null,
      finished: selectedFinish ? selectedFinish?._id : null,
      createdBy: selectedCreatedBy ? selectedCreatedBy?._id : null,
      brand: selectedBrand ? selectedBrand?._id : null,
      subBrand: selectedSubBrand ? selectedSubBrand?._id : null,
      productType: selectedProductType ? selectedProductType?._id : null,
      category1: selectedCategory1 ? selectedCategory1?._id : null,
      category2: selectedCategory2 ? selectedCategory2?._id : null,
      category3: selectedCategory3 ? selectedCategory3?._id : null,
      category4: selectedCategory4 ? selectedCategory4?._id : null,
    };
    getBomLib(params);
  };

  const handleDeleteCard = async (id) => {
    setBomId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const handleLibAdded = async (obj) => {
    const res = await dispatch(action.AddBomBomLibaray(obj, t));
    const params = {
      bomTypeId: paramId,
      pageIndex: 1,
      pageSize: state.pageSize,
      isNewAdded: true,
      ...(state.searchText && { searchText: state.searchText }),
      ...(state.sortBy && { sortOrder: state.sortBy?.value, sortPropertyName: state.sortBy?.propertyName }),
      ...(!isFilterNull && { ...paramsForFilter }),
    };
    setSelectedIdArray([]);
    setState((libAddstate) => ({
      ...libAddstate,
      loading: true,
      pageIndex: 1,
      searchText: '',
      sortBy: null,
    }));
    await Promise.all([dispatch(action.clearLibraryList()), dispatch(action.getBomLibraryGroup(params, t))]);
    return res;
  };

  const handleLibEdit = async (obj, id) => {
    const res = await dispatch(action.EditBomLibaray(obj, id, t));
    const params = {
      bomTypeId: paramId,
      pageIndex: 1,
      pageSize: state.pageSize,
      isOldEdit: true,
      ...(state.searchText && { searchText: state.searchText }),
      ...(state.sortBy && { sortOrder: state.sortBy?.value, sortPropertyName: state.sortBy?.propertyName }),
      ...(!isFilterNull && { ...paramsForFilter }),
    };
    setState((editLibstate) => ({
      ...editLibstate,
      loading: true,
      pageIndex: 1,
      // searchText: "",
      sortBy: null,
      bomLibraryList: [],
    }));
    await dispatch(action.clearLibraryList());
    await dispatch(action.getBomLibraryGroup(params, t));
    setSelectedIdArray([]);
    return res;
  };

  const handleShow = () => {
    setShow(true);
  };

  useEffect(() => {
    if (selectedCategory1 && selectedCategory2) {
      const callCategory3Api = async () => {
        const cat3params = {
          categoryOneId: selectedCategory1._id,
          categoryTwoId: selectedCategory2._id,
          categoryType: 3,
          loggedInUserId,
          isActive: true,
        };
        await dispatch(masterAction.getCategory3Details(cat3params, false));
      };
      callCategory3Api();
    }
  }, [selectedCategory1, selectedCategory2, dispatch, loggedInUserId]);

  useEffect(() => {
    if (selectedCategory1 && selectedCategory2 && selectedCategory3) {
      const callCategory4Api = async () => {
        const cat4params = {
          categoryOneId: selectedCategory1._id,
          categoryTwoId: selectedCategory2._id,
          categoryThreeId: selectedCategory3._id,
          categoryType: 4,
          loggedInUserId,
          isActive: true,
        };
        await dispatch(masterAction.getCategory4Details(cat4params));
      };
      callCategory4Api();
    }
  }, [selectedCategory1, selectedCategory2, selectedCategory3, dispatch, loggedInUserId]);

  const getExistingIndex = () => {
    return localstorageFilter?.findIndex((element) => `${paramId}_Type` in element);
  };

  const getSelectedValue = (selectedValue) => {
    return selectedValue || null;
  };
  const onSubmitFilter = async (filterParams) => {
    setState((filterState) => ({ ...filterState, loading: true }));
    const params = {
      bomTypeId: paramId,
      pageIndex: 1,
      pageSize: state.pageSize,
      searchText: state.searchText,
      sortBy: state.sortBy,
      bomLibraryList: [],
      totalRecords: null,
      isSelectAll: false,
      selectedIdArray: [],
      ...filterParams,
    };

    const res = await dispatch(action.getBomLibraryGroup(params, t));
    if (res) {
      setShow(false);
      setState((filters) => ({ ...filters, loading: false }));
    }
  };
  const defaultParamCalled = () => {
    if (!isFilterNull) {
      setInFilter(true);

      const paramsForFilterWithKeyVal = {
        componentSupplier: getSelectedValue(selectedCompSupplier),
        componentType: getSelectedValue(selectedCompType),
        composition: getSelectedValue(selectedComposition),
        finished: getSelectedValue(selectedFinish),
        createdBy: getSelectedValue(selectedCreatedBy),
        brand: getSelectedValue(selectedBrand),
        subBrand: getSelectedValue(selectedSubBrand),
        productType: getSelectedValue(selectedProductType),
        category1: getSelectedValue(selectedCategory1),
        category2: getSelectedValue(selectedCategory2),
        category3: getSelectedValue(selectedCategory3),
        category4: getSelectedValue(selectedCategory4),
      };
      const ids = JSON.stringify(paramsForFilter);
      const objs = JSON.stringify(paramsForFilterWithKeyVal);
      const removeIndex = getExistingIndex();

      const localFilter = localstorageFilter || [];
      // Remove Old filter for Bom Type If already in localstorage
      if (removeIndex > -1) {
        localFilter.splice(removeIndex, 1);
      }
      const libObject = [
        ...localFilter,
        {
          [`${paramId}_Type`]: { selectedIds: ids, selectedObject: objs },
        },
      ];

      localStorage.setItem('libraryBOMFilter', JSON.stringify(libObject));
      onSubmitFilter(paramsForFilter);
    }
  };
  const forLibFilter = async (val, eve) => {
    switch (val) {
      case 'productType':
        // Set selected Product Type from ComponentFilter and clear dependent categories
        setSelectedProductType(eve || null);
        setSelectedCategory1(null);
        setSelectedCategory2(null);
        setSelectedCategory3(null);
        setSelectedCategory4(null);
        break;
      case 'op1':
        setSelectedCompSupplier(eve);
        break;
      case 'op2':
        setSelectedCompType(eve);
        break;
      case 'op3':
        setSelectedFinish(eve);
        break;
      case 'op4':
        setSelectedComposition(eve);
        break;
      case 'op5':
        setSelectedCreatedBy(eve);
        break;
      case 'op6':
        // Clear subbrand when brand is changed or deselected
        if (!eve || (selectedBrand && eve && selectedBrand._id !== eve._id)) {
          setSelectedSubBrand(null);
        }
        setSelectedBrand(eve);
        break;
      case 'op11':
        setSelectedSubBrand(eve);
        break;
      case 'op7':
        setSelectedCategory1(eve);
        if (selectedCategory3) {
          setSelectedCategory3(null);
        }
        if (selectedCategory4) {
          setSelectedCategory4(null);
        }
        break;
      case 'op8':
        setSelectedCategory2(eve);
        if (selectedCategory3) {
          setSelectedCategory3(null);
        }
        if (selectedCategory4) {
          setSelectedCategory4(null);
        }
        break;
      case 'op9':
        setSelectedCategory3(eve);
        if (selectedCategory4) {
          setSelectedCategory4(null);
        }
        break;
      case 'op10':
        setSelectedCategory4(eve);
        break;
      case 'clear':
        setInFilter(false);
        setSelectedCompSupplier(null);
        setSelectedCompType(null);
        setSelectedComposition(null);
        setSelectedFinish(null);
        setSelectedCreatedBy(null);
        setSelectedProductType(null);
        setSelectedCategory1(null);
        setSelectedCategory2(null);
        setSelectedCategory3(null);
        setSelectedCategory4(null);
        setSelectedBrand(null);
        setSelectedSubBrand(null);
        onSubmitFilter();
        const localFilter = localstorageFilter || [];
        const removeIndex = getExistingIndex();
        // Remove Old filter for Bom Type If already in localstorage
        if (removeIndex > -1) {
          localFilter.splice(removeIndex, 1);
        }
        localStorage.setItem('libraryBOMFilter', JSON.stringify(localFilter));
        break;

      default:
        defaultParamCalled();
        break;
    }
  };

  const toggleBomTagsModel = () => {
    setAddBomTagsModal(!addBomTagsModal);
  };

  const onAddBomTags = (id) => {
    setAddBomTagsModal(true);
    setSelectedTagId(id);
  };

  const bomOptions = [
    { value: bomLibrary, label: bomLibrary },
    { value: 'Tags', label: t('BOM_TYPE_VIEW.BOM_TYPE_POPUP_VIEW.TAGS') },
  ];

  const customStyles = {
    option: (provided) => ({
      ...provided,
      padding: '5px 10px',
    }),
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      // border: "1px solid #848484",
      borderRight: '1px solid #f0f0f0',
      height: '35px',
      minWidth: '150px',
      padding: '5px 0 5px 5px',
      fontSize: '14px',
      background: '#FFF',
    }),
    singleValue: (provided, states) => {
      const opacity = states.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    },
    menu: (provided) => ({
      ...provided,
      margin: '-1px 0 0 0',
      border: '1px solid #848484',
      borderRadius: 0,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
      color: '#555',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#848484',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
  };

  const handleChangeBomFilter = (value) => {
    setBomFilterType(value);
    setState((prev) => ({
      ...prev,
      searchText: '',
    }));
  };

  const arr = [];

  const tagsoptions = tagListBom
    .map((ele) => {
      return { label: ele, value: ele };
    })
    .filter((item) => {
      if (arr.includes(item.label)) return false;
      arr.push(item.label);
      return true;
    });

  useEffect(() => {
    dispatch(action.fetchBomLibraryTagsAction());
  }, [dispatch]);

  useEffect(() => {
    const defaultPlace = [{ label: `Search ${BOMProperty?.name?.toLowerCase()} library...` }];
    setSearchtagselected(defaultPlace);
  }, [BOMProperty]);

  const multyHandler = async (val) => {
    if (searchtagselected.find((item) => item?.label.includes('Search'))) {
      setSearchtagselected([...val.filter((item) => !item?.label.includes('Search'))]);
    } else if (val.length === 0) {
      setSearchtagselected([{ label: `Search ${BOMProperty?.name?.toLowerCase()} library...` }]);
    } else {
      setSearchtagselected([...val]);
    }
    const selectinput = [...val.filter((item) => !item?.label.includes('Search'))];
    const data = selectinput.map((ele) => {
      return ele.value;
    });

    const params2 = {
      bomTypeId: paramId,
      pageIndex: 1,
      pageSize: state.pageSize,
      searchBomTags: data,
      ...(state.searchText && { searchText: state.searchText }),
      ...(state.sortBy && { sortOrder: state.sortBy?.value, sortPropertyName: state.sortBy?.propertyName }),
      ...(!isFilterNull && { ...paramsForFilter }),
    };

    await dispatch(action.getBomLibraryGroup(params2, t));
  };
  const getName = (name) => {
    if (name) {
      let nameSpilt = name?.split(' ');
      nameSpilt = nameSpilt?.map((na) => na.charAt(0).toUpperCase() + na.slice(1));
      return nameSpilt.join(' ') || '--';
    }
    return ' ';
  };

  const setInitialState = () => {
    setState((oldState) => ({
      ...oldState,
      pageIndex: 1,
      searchLoaded: false,
      searchText: '',
      hasMore: true,
      loading: true,
    }));
  };

  const uploadBOMXlsx = async () => {
    setShowModal(true);
  };
  const closeUploadModal = () => {
    setShowModal(false);
  };

  const hasDuplicateBOMCode = (data) => {
    if (state?.bomLibraryList?.length > 0) {
      const bomData = [];
      const array = state?.bomLibraryList?.find((element) =>
        data.some((obj) => obj['Component Code'] === element.referenceCode || obj['Component Code *'] === element.referenceCode),
      );
      // eslint-disable-next-line no-unused-expressions
      array && bomData.push(array);
      return bomData;
    }
    return [];
  };
  const uploadExcelDocument = async (value, object, fileData, componentMapping) => {
    const formData = new FormData();
    const obj = {
      ...uploadData,
      AddToTheBomLibrary: value,
      isUpdate: !!checked,
      bomTypeId: urlParams?.id,
      file,
    };
    formData.append('file', fileData);
    formData.append('headers', JSON.stringify(object.headers));
    formData.append('xlsxData', JSON.stringify(object.xlsxData));
    formData.append('bomTypeId', obj.bomTypeId);
    formData.append('isUpdate', obj.isUpdate);
    formData.append('componentMapping', JSON.stringify(componentMapping));

    const res = await dispatch(action.uploadBOMXlsxFile(formData, t));
    if (res.code === 200) {
      await dispatch(action.clearLibraryList());
      closeUploadModal();
      setChecked(false);
      setUploadData({});
      const ObjectData = { isAllRecord: true, bomTypeId: urlParams?.id };
      const res1 = await dispatch(action.fetchBomLibraryList(ObjectData));
      setState({ ...state, bomLibraryList: res1?.data || [] });
      if (res?.data?.error?.length > 0) {
        setErrorShow(true);
      }
      if (res?.data?.fileName) {
        setFileName(res?.data?.fileName);
      }
    }
  };

  const togglePreview = async () => {
    setUploadModal(false);
  };

  const toggleErr = () => {
    setErrorShow(false);
  };

  const handleErrorDownload = () => {
    const fileUrl = fileName.startsWith('http') ? fileName : `${imageUrl}${fileName}`;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', fileName); // Set the desired filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCheckboxChange = () => {
    setChecked(!checked);
  };

  const handleNoButtonClick = async () => {
    setUploadModal(false);
    setChecked(false);
  };

  const handleYesButtonClick = async () => {
    setUploadModal(false);
    setChecked(true);
    await uploadExcelDocument(true, uploadData, file, composition);
  };

  const filterData = (data) => {
    if (data?.length > 0) {
      const componentMapping = {};

      const filteredXlsxData = data.filter((entry) => {
        const componentCode = entry['Component Code'];
        const bomType = entry['BOM Type'];
        const componentType = entry['Component Type'];
        const percentage = entry.Percentage;
        const compositionData = entry.Composition;

        if (percentage !== '--' && compositionData !== '--') {
          if (componentCode === '--' && (percentage || compositionData)) {
            // If there is a previous entry with a valid component code, push a new entry with percentage and composition
            const previousEntryKey = Object.keys(componentMapping).pop();
            const previousEntry = componentMapping[previousEntryKey];
            if (previousEntry) {
              componentMapping[previousEntryKey] = [
                ...componentMapping[previousEntryKey],
                { Percentage: percentage || '', Composition: compositionData || '' },
              ];
            }
            // Do not include this entry in the filtered array
            return false;
          }
          if (componentCode !== '--') {
            // If the component code is not '--', add it to the mapping with a new array containing the current entry
            componentMapping[componentCode] = [{ Percentage: percentage || '', Composition: compositionData || '' }];
          }
        }
        return !(componentCode === '--' && bomType === '--' && componentType === '--');
      });
      setComposition(componentMapping);
      // Print the filtered result
      return { xlsxData: filteredXlsxData, componentMapping };
    }
  };

  const addDocument = async () => {
    if (docRef?.current) {
      const uploadedDoc = await docRef.current.selectedDocument();
      if (uploadedDoc) {
        const files = uploadedDoc.document;
        setFile(files);
        const convertedXlsxToArray = await treadFile(files, true, ['SuppliersList']);
        if (convertedXlsxToArray?.data?.length === 0) {
          toasterMsg('Please upload valid file', 'danger');
          return;
        }
        const excelData = filterData(convertedXlsxToArray.data);
        const obj = {
          xlsxData: excelData?.xlsxData,
          headers: convertedXlsxToArray?.headerKeys,
        };
        const checkDuplicatePomCode = hasDuplicateBOMCode(convertedXlsxToArray?.data);
        setUploadData(obj);
        if (checkDuplicatePomCode && checkDuplicatePomCode.length > 0) {
          setUploadModal(true);
          closeUploadModal();
        } else {
          await uploadExcelDocument(false, obj, files, excelData.componentMapping);
          closeUploadModal();
        }
      }
    }
  };
  const handleBulkUpdate = async () => {
    if (isEmpty(selectedIdArray) || isEmpty(bulkUpdateFields)) {
      return;
    }
    try {
      setState((prevState) => ({ ...prevState, loading: true }));
      const fieldsToUpdate = bulkUpdateFields.map((field) => field.value);
      const payload = {
        bomLibraryIds: selectedIdArray,
        fieldsToUpdate,
        bomType: paramId,
      };

      const result = await dispatch(action.bulkUpdateProductBomCosting(payload, t));

      if (result?.code === 200) {
        setShowBulkUpdateSuccess(true);
        setTimeout(() => setShowBulkUpdateSuccess(false), 2000);
        setBulkUpdateFields([]);
        setSelectedIdArray([]);
        const params = {
          bomTypeId: paramId,
          pageIndex: 1,
          pageSize: state.pageSize,
          ...(state.searchText && { searchText: state.searchText }),
          ...(state.sortBy && { sortOrder: state.sortBy?.value, sortPropertyName: state.sortBy?.propertyName }),
          ...(!isFilterNull && { ...paramsForFilter }),
        };
        await Promise.all([dispatch(action.clearLibraryList()), dispatch(action.getBomLibraryGroup(params, t))]);
      }
    } catch (error) {
      console.error('Bulk update error:', error);
      toasterMsg(error?.message || 'Failed to perform bulk update', 'danger');
    } finally {
      setState((prevState) => ({ ...prevState, loading: false }));
    }
  };

  const handleDownload = async (type) => {
    if (type === 'All') {
      setDownloadLoading(true);
      const data = {
        bomTypeId: urlParams?.id,
      };
      await dispatch(action.downloadBomLibrary(data, t));
      setDownloadLoading(false);
    } else if (type === 'Sample') {
      setDownloadLoading(true);
      const data = {
        bomTypeId: urlParams?.id,
        fromSample: true,
      };
      await dispatch(action.downloadBomLibrary(data, t));
      setDownloadLoading(false);
    } else if (type === 'selected') {
      setDownloadSelectLoading(true);
      const data = {
        bomTypeId: urlParams?.id,
        bomLibIds: selectedIdArray,
      };
      await dispatch(action.downloadBomLibrary(data, t));
      setDownloadSelectLoading(false);
    }
  };
  return (
    <>
      {!isAddEditClick && (
        <div className="page-title-filter sticky">
          <div className="title-container">
            <h4 title={BOMProperty?.name} className="title">
              {BOMProperty?.name} {t('BOM_LIBRARY.BOM_LIBRARYS.LIBRARY')}
            </h4>
          </div>
          <div className="search-filter action-btn-nextline">
            {!isEmpty(selectedIdArray) && (
              <div className="selection-count px-1">
                {selectedIdArray.length} {t('BOM_LIBRARY.BOM_LIBRARYS.BOM_SELECTED')}
              </div>
            )}

            <div className="searchBomLibrary">
              <div className="custom-bom-select">
                <Select
                  className="text-dark"
                  options={bomOptions}
                  styles={customStyles}
                  placeholder={bomFilterType}
                  value={bomFilterType}
                  onChange={handleChangeBomFilter}
                />
              </div>
              <div className="tags-search-container">
                {bomFilterType.value === 'Tags' ? (
                  <div>
                    <div className="multiselectsd">
                      <MultiSelect
                        className="custome-bom-filter"
                        options={tagsoptions}
                        value={searchtagselected}
                        onChange={(val) => {
                          multyHandler(val);
                        }}
                        labelledBy={t('BOM_LIBRARY.BOM_LIBRARYS.SEARCH_LIBRARY')}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="searchinput library-search">
                    <SearchBar
                      onSearch={handleSearch}
                      value={state.searchText}
                      placeholder={t(`${t('BOM_LIBRARY.BOM_LIBRARYS.SEARCH')} ${getName(BOMProperty?.name)} ${t('BOM_TYPE_VIEW.BOM_TYPE_POPUP_VIEW.LIBRARY')}`)}
                      showMobileSearch={showSearchMobile}
                      handleMobileSearch={handleMobileSearch}
                    />
                  </div>
                )}
              </div>
            </div>
            <Dropdown className="supplier-more-option">
              <Dropdown.Toggle>
                <button aria-label="Download" className="filter-btn" type="button">
                  <i title={t('BOM_LIBRARY.BOM_LIBRARYS.DOWNLOAD')} className="icon-download" />
                </button>
              </Dropdown.Toggle>
              <Dropdown.Menu align="end">
                <Link className="dropdown-item" to={() => false} onClick={() => handleDownload('Sample')}>
                  {t('BOM_LIBRARY.BOM_LIBRARYS.DOWNLOAD_SAMPLE_FILE')}
                </Link>
                <Button className="dropdown-item" disabled={isEmpty(selectedIdArray)} onClick={() => handleDownload('selected')}>
                  {downloadSelectLoading ? t('BOM_LIBRARY.BOM_LIBRARYS.DOWNLOADING') : t('BOM_LIBRARY.BOM_LIBRARYS.DOWNLOAD_SELECTED_RECORDS')}
                </Button>
                <Button disabled={state?.bomLibraryList?.length < 1} className="dropdown-item" onClick={() => handleDownload('All')}>
                  {downloadLoading ? t('BOM_LIBRARY.BOM_LIBRARYS.DOWNLOADING') : t('BOM_LIBRARY.BOM_LIBRARYS.DOWNLOAD_ALL_RECORDS')}
                </Button>
              </Dropdown.Menu>
            </Dropdown>
            {addEditAccess && (
              <>
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <button type="button" title={t('BOM_LIBRARY.BOM_LIBRARYS.UPLOAD_BOM_EXCEL')} onClick={() => uploadBOMXlsx()} className="filter-btn">
                  <i className="icon-upload" />
                </button>
              </>
            )}

            <BtnAdd onBtnClick={() => openBomLibraryPopup()} addEditAccess={addEditAccess} />
            <BtnAddGroup
              options={bomLibraryGroups}
              onBtnClick={openAddToGroup}
              placeholder={t('BOM_LIBRARY.BOM_LIBRARYS.BOM_LIBRARY_GROUP')}
              isDisabled={isEmpty(selectedIdArray)}
              noOption={t('BOM_LIBRARY.BOM_LIBRARYS.NO_GROUP_AVAILBLE')}
            />
            <BtnSort options={sortByOptions} onBtnClick={handleSortBy} val={state.sortBy} />
            <ComponentFilter
              onBtnClick={forLibFilter}
              placeholder={t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_COMPONENT_SUPLIER')}
              noOption={t('BOM_LIBRARY.BOM_LIBRARYS.SUPLIER_AVAILBLE')}
              placeholder2={t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_COMPONENT_TYPE')}
              noOption2={t('BOM_LIBRARY.BOM_LIBRARYS.NO_COMPONENT_TYPE_AVAILBLE')}
              placeholder3={t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_FINISHED')}
              noOption3={t('BOM_LIBRARY.BOM_LIBRARYS.NO_FINISHED_AVAILBLE')}
              placeholder4={t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_COMPOSITION')}
              noOption4={t('BOM_LIBRARY.BOM_LIBRARYS.NO_COMPOSITION_AVILBLE')}
              placeholder5={t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_CREATED_BY')}
              noOption5={t('BOM_LIBRARY.BOM_LIBRARYS.NO_CREATED_BY_AVAILBLE')}
              placeholder6={t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_BRAND')}
              noOption6={t('BOM_LIBRARY.BOM_LIBRARYS.NO_BRAND_AVAILBLE')}
              placeholderPT={t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.PRODUCT_TYPE')}
              noOptionPT={t('BOM_LIBRARY.BOM_LIBRARYS.NO_PRODUCT_TYPE_AVAILABLE')}
              placeholder7={t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_CATEGORY1')}
              noOption7={t('BOM_LIBRARY.BOM_LIBRARYS.NO_CATEGORY_1_AVAILBLE')}
              placeholder8={t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_CATEGORY2')}
              noOption8={t('BOM_LIBRARY.BOM_LIBRARYS.NO_CATEGORY_2_AVAILBLE')}
              placeholder9={t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_CATEGORY3')}
              noOption9={t('BOM_LIBRARY.BOM_LIBRARYS.NO_CATEGORY_3_AVAILBLE')}
              placeholder10={t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_CATEGORY_4')}
              noOption10={t('BOM_LIBRARY.BOM_LIBRARYS.NO_CATEGORY_4_AVAILBLE')}
              placeholder11={t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_SUB_BRAND')}
              noOption11={t('BOM_LIBRARY.BOM_LIBRARYS.NO_SUB_BRAND_AVAILABLE')}
              selectedItemPT={selectedProductType}
              selectedItem1={selectedCompSupplier}
              selectedItem2={selectedCompType}
              selectedItem3={selectedFinish}
              selectedItem4={selectedComposition}
              selectedItem5={selectedCreatedBy}
              selectedItem6={selectedBrand}
              selectedItem7={selectedCategory1}
              selectedItem8={selectedCategory2}
              selectedItem9={selectedCategory3}
              selectedItem10={selectedCategory4}
              selectedItem11={selectedSubBrand}
              show={show}
              handleShow={handleShow}
              inFilter={inFilter}
            />

            {addEditAccess && (
              <>
                <BtnDelete
                  multiDelete={() => {
                    deleteBomType(null);
                  }}
                  isDisabled={isEmpty(selectedIdArray)}
                />

                <BtnSelectAll handleSelectAll={handleSelectAll} isSelectAll={isSelectAll} isDisabled={isEmpty(state.bomLibraryList)} />
              </>
            )}
            <Link className="cursor-pointer text-dark text-decoration-none " to="/libraries/bom-type">
              <button type="button" className="btn btn-white btn-back-lib">
                {t('BOM_LIBRARY.BOM_LIBRARYS.BACK')}
              </button>
            </Link>
          </div>
        </div>
      )}

      {!isAddEditClick && (
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className={`bulk-update-bom-container ${isEmpty(selectedIdArray) ? 'disabled-bulk-update' : ''}`}>
              <Button
                type="button"
                className={`bulk-update-btn-icon ${!isEmpty(bulkUpdateFields) ? 'bulk-update-btn-active' : ''} ${
                  isEmpty(selectedIdArray) || isEmpty(bulkUpdateFields) ? 'bulk-update-btn-unclickable' : ''
                }`}
                onClick={() => {
                  if (isEmpty(selectedIdArray) || isEmpty(bulkUpdateFields)) return;
                  handleBulkUpdate();
                }}
                aria-label={t('BOM_LIBRARY.BOM_LIBRARYS.BULK_UPDATE_BOM_USAGE') || 'Bulk Update'}
              >
                <i className="icon-Update-1 f-22" />
              </Button>
              <p className="bulk-update-label">{t('BOM_LIBRARY.BOM_LIBRARYS.BULK_UPDATE_BOM_USAGE') || 'Bulk Update BOM Usage'}</p>
              <div className="bulk-update-select">
                <MultiSelect
                  options={bomUsageFields}
                  value={bulkUpdateFields}
                  onChange={setBulkUpdateFields}
                  disabled={isEmpty(selectedIdArray)}
                  className="product-custom-multiselect common-new-multiselect w-100"
                  labelledBy={t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_FIELDS') || 'Select Field(s)'}
                  hasSelectAll
                  overrideStrings={{
                    selectSomeItems: t('BOM_LIBRARY.BOM_LIBRARYS.SELECT_FIELDS') || 'Select Field(s)',
                    allItemsAreSelected: t('BOM_LIBRARY.BOM_LIBRARYS.ALL_SELECTED') || 'All Selected',
                  }}
                />
              </div>
            </div>
            {showBulkUpdateSuccess && (
              <p className="bulk-update-success-msg mb-0 align-self-center">{t('BOM_LIBRARY.BOM_LIBRARYS.BULK_UPDATE_SUCCESS') || 'Bulk Update Successful'}</p>
            )}
            <div className="d-flex">
              <Link
                className={`cursor-pointer text-dark text-decoration-none ${
                  window.location.href.indexOf('/bom-library') > -1 ? 'btn-active btn btn-page-filter' : 'btn btn-page-filter'
                }`}
                to="/libraries/bom-type"
              >
                <span className="lib-name" title={BOMProperty?.name}>
                  <span className="d-none d-md-block">{shortenString(BOMProperty?.name, 20)}</span>
                </span>{' '}
                &nbsp;{t('BOM_LIBRARY.BOM_LIBRARYS.LIBRARY')}
              </Link>
              <Link className="cursor-pointer text-dark text-decoration-none btn btn-page-filter" to={`/libraries/bom-library-group/${paramId}`}>
                <span className="lib-name" title={BOMProperty?.name}>
                  <span className="d-none d-md-block">{shortenString(BOMProperty?.name, 20)}</span>
                </span>{' '}
                &nbsp;{t('BOM_LIBRARY.BOM_LIBRARYS.LIBRARY_GROUP')}
              </Link>
            </div>
          </div>

          <div>
            {!state.loading && state.bomLibraryList.length === 0 && (
              <div className="w-100 text-center">
                <Container fluid className="py-4">
                  <Row>
                    <Col md="12">
                      <p className="alert alert-info override-alert-info">
                        {t('BOM_LIBRARY.BOM_LIBRARYS.NO')} <span className="text-capitalize">{shortenString(BOMProperty?.name, 20)}</span>{' '}
                        {t('BOM_LIBRARY.BOM_LIBRARYS.LIBRARY_ENTRY_FOUND')}
                        <span className="text-capitalize"> {shortenString(BOMProperty?.name, 20)}</span> {t('BOM_LIBRARY.BOM_LIBRARYS.TO_THE_LIBRARY')}
                      </p>
                    </Col>
                  </Row>
                </Container>
              </div>
            )}
          </div>
        </div>
      )}
      {!isAddEditClick && state?.loading && isEmpty(state?.bomLibraryList) && <Loader />}
      {!isAddEditClick && state?.bomLibraryList?.length > 0 ? (
        <InfiniteScroll
          dataLength={state?.bomLibraryList?.length} // This is important field to render the next data
          next={handleNextPagesInScroll}
          hasMore={state?.hasMore}
          loader={state?.loading && <Loader />}
          style={{ marginBottom: '50px' }}
        >
          <div className="container-fluid">
            <div className="row bomcard-row">
              {state.bomLibraryList.map((item, i) => (
                <React.Fragment key={item?._id}>
                  <BomLibraryCard
                    handleExpand={handleExpandToogle}
                    editeble
                    onEdit={onEdit}
                    onAddBomTags={onAddBomTags}
                    item={item}
                    index={i}
                    onDelete={handleDeleteCard}
                    onCheck={onSelectCheckBox}
                    selectedIds={selectedIdArray}
                    isImport={false}
                    fromBomLib
                    isFromLibrary
                    setInitialState={setInitialState}
                  />
                </React.Fragment>
              ))}
            </div>
          </div>
        </InfiniteScroll>
      ) : null}
      {isAddEditClick && (
        <AddEditBomLibrary
          onOpen={isAddEditClick}
          title={
            selectedId
              ? `${t('BOM_TYPE_FORM.EDIT')} ${BOMProperty?.name} ${t('BOM_TYPE_FORM.LIBRARY')}`
              : `${t('BOM_TYPE_FORM.ADD')} ${BOMProperty?.name} ${t('BOM_TYPE_FORM.LIBRARY')}`
          }
          id={selectedId}
          toggle={onClose}
          BOMId={paramId}
          addBomLibaray={(obj) => handleLibAdded(obj)}
          EditBomLibaray={(obj, id) => handleLibEdit(obj, id)}
          BOMProperty={BOMProperty}
          itemList={BOMLibraryList}
          reloadList
          suppliersList={ReferenceSupplier}
          devOrderId={null}
          isFromLibrary
          setIsAddEditClick={setIsAddEditClick}
          dppAddEditAccess={dppAddEditAccess}
        />
      )}
      {showModal && <ImportModal showUploadModal={showModal} closeUploadModal={closeUploadModal} docRef={docRef} addDocument={addDocument} loader={false} />}
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          loading={state.loading}
          title={t('CONFIRMATION_POPUP_VIEW.BOM_TYPE.TITLE')}
          message={t('CONFIRMATION_POPUP_VIEW.BOM_TYPE.DELETE_MESSAGE')}
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
        />
      )}
      {uploadModal && (
        <ConfirmationModalForUpload
          onOpen={uploadModal}
          toggle={togglePreview}
          title={t('BOM_LIBRARY.BOM_LIBRARYS.UPLOAD_BOM_LIBRARY')}
          description={t('BOM_LIBRARY.BOM_LIBRARYS.DUPLICATE_BOM_LIBRARY_FOUND')}
          checked={checked}
          handleCheckboxChange={handleCheckboxChange}
          handleNoButtonClick={handleNoButtonClick}
          handleYesButtonClick={handleYesButtonClick}
        />
      )}
      {errorShow && (
        <ErrorModal title={t('BOM_LIBRARY.BOM_LIBRARYS.UPLOAD_BOM_LIBRARY')} onOpen={errorShow} toggle={toggleErr} handleErrorDownload={handleErrorDownload} />
      )}
      {expand ? (
        <BomExpand
          show={expand}
          handleClose={handleExpandToogle}
          selectedExpand={selectedExpand}
          devOrderId={devOrderId}
          suppliersList={suppliers}
          showApprovedReject={false}
          showColorWayCheckBox={false}
        />
      ) : null}
      {addBomTagsModal && <BomLibraryTagsModel onOpen={addBomTagsModal} toggle={toggleBomTagsModel} BOMId={selectedTagId} />}
    </>
  );
}

export default CustomBom;
